import React from 'react';
import { Github, Linkedin, Twitter, Globe, ChevronDown } from 'lucide-react';
import { PROFILE_DATA } from '../../data/config';

const Hero = () => {
  const socialLinks = [
    { icon: Github, url: PROFILE_DATA.social.github, label: 'GitHub' },
    { icon: Linkedin, url: PROFILE_DATA.social.linkedin, label: 'LinkedIn' },
    { icon: Twitter, url: PROFILE_DATA.social.twitter, label: 'Twitter' },
    { icon: Globe, url: PROFILE_DATA.social.website, label: 'Website' },
  ];

  const scrollToNext = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section 
      id="hero" 
      className="flex items-center justify-center relative"
      style={{
        minHeight: 'max(100vh, 100dvh)',
      }}
    >
      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto py-20">
        {/* Name */}
        <h1 
          className="text-6xl md:text-8xl font-bold mb-4 tracking-tight animate-fade-in"
          style={{
            fontFamily: 'Righteous, sans-serif',
            background: 'linear-gradient(135deg, #f5e6d3 0%, #e8d4bf 25%, #d9c3ab 50%, #cab297 75%, #bba183 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: 'none',
            letterSpacing: '-0.02em'
          }}
        >
          {PROFILE_DATA.name}
        </h1>

        {/* Title */}
        <h2 className="text-2xl md:text-3xl font-semibold gradient-text mb-6 animate-slide-up" style={{ animationDelay: '0.2s' }}>
          {PROFILE_DATA.title}
        </h2>

        {/* Tagline */}
        <p className="text-lg md:text-xl text-cream-200 mb-12 max-w-2xl mx-auto animate-slide-up" style={{ animationDelay: '0.4s' }}>
          {PROFILE_DATA.tagline}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-row items-center justify-center gap-3 mb-16 animate-scale-in px-4" style={{ animationDelay: '0.6s' }}>
          <a href="#contact" className="btn-primary flex-1 max-w-[180px] text-center">
            Get In Touch
          </a>
          <a href="#projects" className="btn-secondary flex-1 max-w-[180px] text-center">
            View My Work
          </a>
        </div>

        {/* Social Links */}
        <div className="flex items-center justify-center gap-4 mb-12 animate-scale-in" style={{ animationDelay: '0.8s' }}>
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="p-4 glass-card hover:bg-glass-light transition-all duration-300"
              aria-label={link.label}
            >
              <link.icon className="w-5 h-5 text-cream-100" />
            </a>
          ))}
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={scrollToNext}
          className="animate-bounce cursor-pointer hover:opacity-70 transition-opacity"
          aria-label="Scroll to next section"
        >
          <ChevronDown className="w-8 h-8 text-cream-200" />
        </button>
      </div>
    </section>
  );
};

export default Hero;
